import { create } from "zustand"

import type { ChatSlice } from "./slices/chat-slice"

import { updateSettingsSection } from "@/api/user-settings-api"

import { createChatSlice } from "./slices/chat-slice"
import { createNamespacedStore } from "./store-factory"

type VideoInsightStore = ChatSlice & {
  videoLanguage: string
  setVideoLanguage: (language: string) => void
}

const defaultVideoLanguage = "en-US"

function createVideoInsightStoreInstance() {
  return create<VideoInsightStore>()((set, get, api) => ({
    ...createChatSlice(set, get, api),
    videoLanguage: defaultVideoLanguage,
    setVideoLanguage: (language: string) => {
      set({ videoLanguage: language })
      // Save to database in background (silently fail if error)
      void updateSettingsSection("video_insight", { video_language: language })
    },
  }))
}

/**
 * Hook to get Video Insight store isolated by sessionType.
 *
 * @param sessionType - Session type identifier
 * @returns Zustand store hook for the specific sessionType
 */
export function useVideoInsightStore(sessionType: string) {
  return createNamespacedStore("video-insight", sessionType, createVideoInsightStoreInstance)
}
